(() => {
  const init = async (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('.dp-trucks__grid');
    const toolbar = root.querySelector('.dp-trucks__toolbar');
    const yearOptions = root.querySelector('[data-year-options]');
    const yearPicker = root.querySelector('[data-year-picker]');
    const yearSummary = root.querySelector('[data-year-summary]');
    const allYearsLabel = yearSummary.textContent.trim();
    const buttons = [...root.querySelectorAll('[data-kind]')];
    const count = root.querySelector('.dp-trucks__count');
    const empty = root.querySelector('.dp-trucks__empty');
    const parseYears = (title) => {
      const years = new Set();
      const ranges = [...title.matchAll(/\b((?:19|20)\d{2})(?:\.5)?\s*[-–—]\s*((?:19|20)\d{2})(?:\.5)?\b/g)];
      ranges.forEach((range) => {
        const start = Number(range[1]);
        const end = Number(range[2]);
        if (end >= start && end - start <= 40) {
          for (let year = start; year <= end; year++) years.add(year);
        }
      });
      if (!ranges.length) {
        [...title.matchAll(/\b(?:19|20)\d{2}(?:\.5)?\b/g)].forEach((match) => years.add(Math.floor(Number(match[0]))));
      }
      return [...years].sort((a, b) => a - b);
    };
    const prepareCard = (card) => {
      const title = card.dataset.productTitle;
      card.years = parseYears(title);
      const badge = card.querySelector('.dp-bundle__year');
      if (card.years.length) {
        badge.textContent = card.years.length === 1 ? card.years[0] : `${card.years[0]}–${card.years[card.years.length - 1]}`;
        badge.hidden = false;
        const clean = title.replace(/\(?\b(?:19|20)\d{2}(?:\.5)?\s*[-–—]\s*(?:19|20)\d{2}(?:\.5)?\b\)?/g, '').replace(/\s*\|\s*/g, ' · ').replace(/(?:\s*·\s*)+$/g, '').replace(/\s{2,}/g, ' ').trim();
        if (clean) card.querySelector('.dp-bundle__title a').textContent = clean;
      } else {
        badge.textContent = root.dataset.unknownYear;
        badge.hidden = false;
      }
    };
    let cards = [...grid.querySelectorAll('.dp-bundle')];
    cards.forEach(prepareCard);

    let next = root.querySelector('[data-next-page]')?.dataset.nextPage;
    let complete = true;
    const visited = new Set();
    try {
      while (next && !visited.has(next)) {
        visited.add(next);
        const response = await fetch(next, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-dp-trucks]');
        if (!page) throw new Error('Collection section unavailable');
        const existing = new Set(cards.map((card) => card.dataset.productId));
        const additions = [...page.querySelectorAll('.dp-bundle')].filter((card) => !existing.has(card.dataset.productId));
        additions.forEach((card) => { prepareCard(card); grid.appendChild(card); });
        cards.push(...additions);
        next = page.querySelector('[data-next-page]')?.dataset.nextPage;
      }
    } catch (_) { complete = false; }
    if (!complete) {
      cards.forEach((card) => { card.hidden = false; });
      count.textContent = root.dataset.countTemplate.replace('__COUNT__', cards.length);
      return;
    }
    root.querySelector('[data-truck-pagination]').hidden = true;
    const allYears = [...new Set(cards.flatMap((card) => card.years))].sort((a, b) => b - a);
    const allYearOption = yearOptions.querySelector('.dp-trucks__year-option');
    allYears.forEach((year) => {
      const option = allYearOption.cloneNode(true);
      const input = option.querySelector('[data-truck-year]');
      input.value = String(year);
      input.checked = false;
      input.removeAttribute('checked');
      option.lastElementChild.textContent = String(year);
      yearOptions.appendChild(option);
    });
    const params = new URLSearchParams(location.search);
    let kind = ['bundle', 'part', 'all'].includes(params.get('kit_type')) ? params.get('kit_type') : root.dataset.defaultKind;
    let selectedYear = allYears.includes(Number(params.get('truck_year'))) ? params.get('truck_year') : '';
    const yearInputs = [...yearOptions.querySelectorAll('[data-truck-year]')];

    const apply = (updateURL) => {
      const year = Number(selectedYear);
      let visible = 0;
      cards.forEach((card) => {
        const match = (kind === 'all' || card.dataset.productKind === kind) && (!year || card.years.includes(year));
        card.hidden = !match;
        if (match) visible++;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.kind === kind)));
      yearInputs.forEach((input) => { input.checked = input.value === selectedYear; });
      yearSummary.textContent = selectedYear || allYearsLabel;
      count.textContent = (visible === 1 ? root.dataset.countOne : root.dataset.countTemplate.replace('__COUNT__', visible)) + (year ? root.dataset.yearTemplate.replace('__YEAR__', year) : '');
      empty.hidden = visible > 0;
      root.querySelector('[data-show-all]').hidden = kind === 'all' || !cards.some((card) => !year || card.years.includes(year));
      toolbar.querySelector('[data-reset]').hidden = !year && kind === root.dataset.defaultKind;
      if (updateURL) {
        const url = new URL(location.href);
        year ? url.searchParams.set('truck_year', year) : url.searchParams.delete('truck_year');
        kind !== root.dataset.defaultKind ? url.searchParams.set('kit_type', kind) : url.searchParams.delete('kit_type');
        url.searchParams.delete('page');
        history.replaceState(null, '', url);
      }
    };
    yearOptions.addEventListener('change', (event) => {
      if (!event.target.matches('[data-truck-year]')) return;
      selectedYear = event.target.value;
      apply(true);
    });
    root.querySelector('[data-show-all]').addEventListener('click', () => { kind = 'all'; apply(true); });
    buttons.forEach((button) => button.addEventListener('click', () => { kind = button.dataset.kind; apply(true); }));
    root.querySelectorAll('[data-reset]').forEach((button) => button.addEventListener('click', () => { selectedYear = ''; kind = root.dataset.defaultKind; apply(true); }));
    window.addEventListener('popstate', () => {
      const current = new URLSearchParams(location.search);
      selectedYear = allYears.includes(Number(current.get('truck_year'))) ? current.get('truck_year') : '';
      kind = ['bundle', 'part', 'all'].includes(current.get('kit_type')) ? current.get('kit_type') : root.dataset.defaultKind;
      apply(false);
    });
    const desktop = window.matchMedia('(min-width: 990px)');
    const summary = yearPicker.querySelector('summary');
    const syncLayout = () => {
      yearPicker.open = desktop.matches;
      summary.tabIndex = desktop.matches ? -1 : 0;
    };
    summary.addEventListener('click', (event) => {
      if (desktop.matches) event.preventDefault();
    });
    desktop.addEventListener('change', syncLayout);
    syncLayout();
    root.querySelector('[data-truck-filters]').hidden = false;
    root.dataset.filtersReady = 'true';
    toolbar.hidden = false;
    apply(false);
  };
  document.querySelectorAll('[data-dp-trucks]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dp-trucks]').forEach(init));
})();
